import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { module } from "app/modules/equipment-registration/equipment-registration.module";
import { Mawop } from 'app/modules/equipment-registration/model/mawop.model';
import { MawopService } from 'app/modules/equipment-registration/services/mawop.service';

@Component({
  selector: 'app-edit-mawop-modal',
  templateUrl: './edit-mawop-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: module,
  styleUrls: ['./edit-mawop-modal.component.scss']
})
export class EditMawopModalComponent {
  casingform: FormGroup
  payload: Mawop = {
    id: null,
    wellStringId: null,
    platformShortName: null,
    platformLongName: null,
    fieldShortName: null,
    fieldLongName: null,
    wellShortName: null,
    wellLongName: null,
    stringShortName: null,
    stringLongName: null,
    stringIndicatorShortName: null,
    wellProductionStatus: null,
    annAPress: null,
    annBPress: null,
    annCPress: null,
    annDPress: null,
    tubingCasingInch: null,
    productionCasingInch: null,
    intermediateCasingInch: null,
    surfaceCasingInch: null,
    conductorCasingInch: null,
    inputDate: null,
  }

  constructor(
    public dialogRef: MatDialogRef<EditMawopModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private mawopService: MawopService
  ) { }

  ngOnInit() {
    this.casingform = this.formBuilder.group({
      tubing: this.data?.tubingCasingInch,
      production: this.data?.productionCasingInch,
      intermediate: this.data?.intermediateCasingInch,
      surface: this.data?.surfaceCasingInch,
      conductor: this.data?.conductorCasingInch,
    });
  }

  updateMAWOP() {
    this.payload.id = this.data?.id
    this.payload.wellStringId = this.data?.wellStringId
    this.payload.tubingCasingInch = this.casingform.get('tubing').value
    this.payload.productionCasingInch = this.casingform.get('production').value
    this.payload.intermediateCasingInch = this.casingform.get('intermediate').value
    this.payload.surfaceCasingInch = this.casingform.get('surface').value
    this.payload.conductorCasingInch = this.casingform.get('conductor').value

    this.mawopService.updateMawop(this.payload).subscribe(res => {
      this.dialogRef.close({ isUpdate: true });
    });
  }
}
